import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from '../../../components/hooks/useForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import { MenuItem } from '@mui/material';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';

import ErrorDialog from '../../../components/ErrorDialog';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { TextInput } from '../../../components/textInput/TextInput';

import Box from '@mui/material/Box';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_DELEGACIONES } from '../../../data/graphQL/queries/Instituciones/getDelegaciones';
import { GET_DELEGACION_NH_SAP } from '../../../data/graphQL/queries/Instituciones/getDelegacionNHSAP';
import { GET_PROVINCIAS } from '../../../data/graphQL/queries/Instituciones/getProvincias';
import { GET_LOCALIDADES } from '../../../data/graphQL/queries/Instituciones/getLocalidades';
import { GET_TIPO_INSTITUCIONES } from '../../../data/graphQL/queries/Instituciones/getTipoInstituciones';
import { GET_UNIDADES_SOPORTE } from '../../../data/graphQL/queries/Instituciones/getUnidadesSoporte';
import { GET_INSTITUCION_DELEGACION } from '../../../data/graphQL/queries/Instituciones/getInstitucionDelegacion';
import { GET_ULTIMO_CODIGO_INSTITUCION } from '../../../data/graphQL/queries/Instituciones/getUltimoCodigoInstitucion';
import { GET_INSTITUCIONES_SAP } from '../../../data/graphQL/queries/Instituciones/getInstitucionesSAP';

import './institucion.scss';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { normalizeFilterValue } from '../../../helpers/tools';

export default function Institucion({ setChildrenAction }) {

  const URL_RETORNO = '/institucionAdmin';

  const { state } = useLocation();
  const navigate = useNavigate();

  // valores posibles de opcion: 0: visualiza, 1: edita, 2: nuevo
  const { institucion, edit, opcion } = state;

  const idDelegacion = useRef(0);
  const txtProvincia = useRef(null);

  const theme = useTheme();
  const [comboDelegaciones, setComboDelegaciones] = React.useState([]);

  const [ultimoCodigoInstitucionNH, setUltimoCodigoInstitucionNH] = React.useState('');

  const [selectedSAPFilter, setSelectedSAPFilter] = useState(institucion.origen === 'SAP' ? 1 : 0);

  // constantes para verificación de la Delegación actual entre NH y SAP
  const [mostrarActualizarDelegacion, setMostrarActualizarDelegacion] = useState(false);
  const [delegacionActualSAP, setDelegacionActualSAP] = useState('');

  const [formValues, formHandle, reset, setFormValues] = useForm({
    CodInstitucion: institucion.cod_Institucion,
    Nombre: institucion.nombre,
    IdDelegacion: institucion.idDelegacion,
    Origen: institucion.origen,
    OrigenSAP: institucion.origen === 'SAP',
    NombreFantasia: institucion.nombreFantasia,
    Domicilio: institucion.domicilio,
    Activo: institucion.activo,
    TipoUnidad: institucion.tipoUnidad,
    IdLocalidad: institucion.idLocalidad,
    IdProvincia: institucion.idProvincia,
    TipoInstitucion: institucion.tipoInstitucion,
    Localidad: institucion.localidad,
    Provincia: institucion.provincia
  });

  const [openDlgSAP, setOpenDlgSAP] = useState(false);
  const [openDlgLocalidades, setOpenDlgLocalidades] = useState(false);

  const [institucionesSAP, setInstitucionesSAP] = useState('');
  const [institucionesSAPOriginal, setInstitucionesSAPOriginal] = useState('');
  const [institucionesSAPAll, setInstitucionesSAPOriginalAll] = useState('');
  const [localidades, setLocalidades] = useState('');
  const [localidadesOriginal, setLocalidadesOriginal] = useState('');

  const [delegaciones, setDelegaciones] = useState([]);
  const [tipoInstituciones, setTipoInstituciones] = useState([]);
  const [unidadesSoporte, setUnidadesSoporte] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [delegacionSAP, setDelegacionSAP] = useState(0);
  const [loadingBuscarInstitucionSAP, setLoadingBuscarInstitucionSAP] = useState(false);
  const [loadingBuscarLocalidades, setLoadingBuscarLocalidades] = useState(false);

  const txtFiltro = useRef(null);
  const txtFiltroLocalidad = useRef(null);
  const [provincia, setProvincia] = useState(0);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    getDelegaciones({ variables: { idRegion: 0 } });
    getUnidadSoporte();
    getTipoInstituciones();
    getProvincias();
    if (opcion === 2)
    getUltimoCodigoInstitucionNH();

    if (institucion.origen === 'SAP')
    getDelegacionNHSAP({ variables: { codInstitucion: formValues.CodInstitucion } });
  }, []);

  useEffect(() => {
    if (edit) {
      getLocalidades({ variables: { idProvincia: txtProvincia.current.value } });
      getInstitucionesSAP({ variables: { idDelegacion: institucion.idDelegacion } });
    }

  }, [provincia]);

  useEffect(() => {
    if (edit) {
      if (localidades) {
        const localidad = localidades.find((x) => x.idLocalidad == formValues.IdLocalidad);
        if (localidad) {
          setFormValues({
            ...formValues,
            Localidad: localidad.descripcion,
            IdLocalidad: localidad.idLocalidad
          });
        }
      }
    }
  }, [localidades]);

  useEffect(() => {
    setChildrenAction(() =>
    <div className='institucion-accion'>
                <CustomButton
        variant='outlined'
        className='margin-right'
        onClick={clickCancel}
        outlinedGray={true}>
        
                    Cancelar
                </CustomButton>

                {
      edit == true &&
      <CustomButton
        onClick={handleClickGrabar}>
        
                        Guardar
                    </CustomButton>
      }
            </div>
    );
  }, [setChildrenAction, formValues, comboDelegaciones]);

  // Guardar Institucion
  const MGuardarInstitucion = gql`
    mutation MGuardarInstitucion( $codInstitucion: String!, $nombre: String!, $idDelegacion: Int!, $origen: String!, $nombreFantasia: String!, $domicilio: String!, $activo: Boolean!, $tipoUnidad: Int!, $idLocalidad: Int!, $idProvincia: Int!, $tipoInstitucion: Int!, $listaDelegaciones: [InstitucionesDelegacionesInput!]!){
        saveInstitucion(model: {
            cod_Institucion: $codInstitucion,
            nombre: $nombre,
            idDelegacion: $idDelegacion,
            origen: $origen,
            nombreFantasia: $nombreFantasia,
            domicilio: $domicilio,
            activo: $activo
            tipoUnidad: $tipoUnidad,
            idLocalidad: $idLocalidad,
            idProvincia: $idProvincia,
            tipoInstitucion: $tipoInstitucion,
            listaDelegaciones: $listaDelegaciones
        }) {
            success,
            error,
            valorEsperado
        }
    }`;

  const [saveInstitucion, { dataMGuardarInstitucion }] = useMutation(MGuardarInstitucion, {
    onCompleted: (dataMGuardarInstitucion) => {
      if (dataMGuardarInstitucion.saveInstitucion.success) {
        toast.success("Se creo la institución correctamente");
        navigate(URL_RETORNO);
      } else {
        if (dataMGuardarInstitucion.saveInstitucion.error === 'ERRORDB' || parseInt(dataMGuardarInstitucion.saveInstitucion.error, 10) > 0) {
          setMensajeError(dataMGuardarInstitucion.saveInstitucion.error);
        } else
        {
          toast.error(dataMGuardarInstitucion.saveInstitucion.error);
        }
      }
    },
    onError: (dataMGuardarInstitucion) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  // Actualizar Institucion
  const MUpdateInstitucion = gql`
    mutation MUpdateInstitucion( $codInstitucion: String!, $nombre: String!, $idDelegacion: Int!, $origen: String!, $nombreFantasia: String!, $domicilio: String!, $activo: Boolean!, $tipoUnidad: Int!, $idLocalidad: Int, $idProvincia: Int!, $tipoInstitucion: Int!, $listaDelegaciones: [InstitucionesDelegacionesInput!]!){
        updateInstitucion(model: {
            cod_Institucion: $codInstitucion,
            nombre: $nombre,
            idDelegacion: $idDelegacion,
            origen: $origen,
            nombreFantasia: $nombreFantasia,
            domicilio: $domicilio,
            activo: $activo
            tipoUnidad: $tipoUnidad,
            idLocalidad: $idLocalidad,
            idProvincia: $idProvincia,
            tipoInstitucion: $tipoInstitucion,
            listaDelegaciones: $listaDelegaciones
        }) {
            success,
            error,
            valorEsperado
        }
    }`;

  const [updateInstitucion, { dataMUpdateInstitucion }] = useMutation(MUpdateInstitucion, {
    onCompleted: (dataMUpdateInstitucion) => {
      if (dataMUpdateInstitucion.updateInstitucion.success) {
        toast.success("Se actuliazo la institución correctamente");
        navigate(URL_RETORNO);
      } else {
        if (dataMUpdateInstitucion.updateInstitucion.error === 'ERRORDB' || parseInt(dataMUpdateInstitucion.updateInstitucion.error, 10) > 0) {
          setMensajeError(dataMGuardarInstitucion.updateInstitucion.error);
        } else
        {
          toast.error(dataMUpdateInstitucion.updateInstitucion.error);
        }
      }
    },
    onError: (dataMUpdateInstitucion) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const [getDelegaciones, { error: errorDelegaciones, data: dataDeleg }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDeleg) return;
    if (dataDeleg.delegaciones.success) {
      setDelegaciones(dataDeleg.delegaciones.valorEsperado);
      if (edit)
      getInstitucionDelegacion({ variables: { codInstitucion: formValues.CodInstitucion } });
    };
  }, [dataDeleg]);

  useEffect(() => {
    if (!errorDelegaciones) return;
    setMensajeError("ERRORDB");
  }, [errorDelegaciones]);

  const [getProvincias, { error: errorProvincias, data: dataProvincias }] = useLazyQuery(GET_PROVINCIAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProvincias) return;
    if (dataProvincias.provincias.success) {
      setProvincias(dataProvincias.provincias.valorEsperado);
    };
  }, [dataProvincias]);

  useEffect(() => {
    if (!errorProvincias) return;
    setMensajeError("ERRORDB");
  }, [errorProvincias]);

  const [getLocalidades, { error: errorLocalidades, data: dataLocalidades, loading: localidadesLoading }] = useLazyQuery(GET_LOCALIDADES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataLocalidades) return;
    if (dataLocalidades.localidades.success) {
      setLocalidades(dataLocalidades.localidades.valorEsperado);
      setLocalidadesOriginal(dataLocalidades.localidades.valorEsperado);
    };
  }, [dataLocalidades]);

  useEffect(() => {
    if (!errorLocalidades) return;
    setMensajeError("ERRORDB");
  }, [errorLocalidades]);

  const [getTipoInstituciones, { error: errorTipoInstituciones, data: dataTipoInstituciones }] = useLazyQuery(GET_TIPO_INSTITUCIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoInstituciones) return;
    if (dataTipoInstituciones.tipoInstituciones.success) {
      setTipoInstituciones(dataTipoInstituciones.tipoInstituciones.valorEsperado);
    };
  }, [dataTipoInstituciones]);

  useEffect(() => {
    if (!errorTipoInstituciones) return;
    setMensajeError("ERRORDB");
  }, [errorTipoInstituciones]);

  const [getUnidadSoporte, { error: errorUnidadSoporte, data: dataUnidadSoporte }] = useLazyQuery(GET_UNIDADES_SOPORTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUnidadSoporte) return;
    if (dataUnidadSoporte.unidadSoporte.success) {
      setUnidadesSoporte(dataUnidadSoporte.unidadSoporte.valorEsperado);
    };
  }, [dataUnidadSoporte]);

  useEffect(() => {
    if (!errorUnidadSoporte) return;
    setMensajeError("ERRORDB");
  }, [errorUnidadSoporte]);

  const [getInstitucionDelegacion, { error: errorInstitucionDelegacion, data: dataInstitucionDelegacion }] = useLazyQuery(GET_INSTITUCION_DELEGACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInstitucionDelegacion) return;
    if (dataInstitucionDelegacion.institucionDelegacion.success) {
      const institucionDelegaciones = dataInstitucionDelegacion.institucionDelegacion.valorEsperado;
      const listaDelegaciones = delegaciones.filter((x) => {
        let resultado = institucionDelegaciones.find((y) => {
          return y.idDelegacion == x.idDelegacion;
        });
        return resultado != undefined;
      }).map((x) => x.descripcion);
      setComboDelegaciones(listaDelegaciones);
    };
  }, [dataInstitucionDelegacion]);

  useEffect(() => {
    if (!errorInstitucionDelegacion) return;
    setMensajeError("ERRORDB");
  }, [errorInstitucionDelegacion]);

  const [getDelegacionNHSAP, { data: dataDelegacionNHSAP, error: errorDelegacionNHSAP }] = useLazyQuery(GET_DELEGACION_NH_SAP, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionNHSAP) return;
    if (dataDelegacionNHSAP.institucionDelegacionNHSAP.success && dataDelegacionNHSAP.institucionDelegacionNHSAP.valorEsperado != null) {
      const nodo = dataDelegacionNHSAP.institucionDelegacionNHSAP.valorEsperado;
      setMostrarActualizarDelegacion(nodo.codDelegacion_SAP !== nodo.codDelegacion_NH);
      setDelegacionActualSAP(nodo.idDelegacion_SAP);

      // completo datos de consulta a SAP si faltan en NH
      let domicilio = formValues.Domicilio;
      let idProvincia = formValues.IdProvincia;
      let provincia = formValues.Provincia;
      let localidad = formValues.Localidad;
      if (formValues.Domicilio == "")
      domicilio = nodo.domicilio;
      if (formValues.IdProvincia == 0)
      idProvincia = nodo.idProvincia;
      if (formValues.Provincia == "")
      provincia = nodo.provincia;
      if (formValues.IdLocalidad == 0)
      localidad = nodo.localidad;

      setFormValues({
        ...formValues,
        Domicilio: domicilio,
        IdProvincia: idProvincia,
        Provincia: idProvincia,
        Localidad: localidad
      });
    };
  }, [dataDelegacionNHSAP]);

  useEffect(() => {
    if (!errorDelegacionNHSAP) return;
    setMensajeError("ERRORDB");
  }, [errorDelegacionNHSAP]);

  const [getUltimoCodigoInstitucionNH, { error: errorUltimoCodigoInstitucionNH, data: dataUltimoCodigoInstitucionNH }] = useLazyQuery(GET_ULTIMO_CODIGO_INSTITUCION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUltimoCodigoInstitucionNH) return;
    if (dataUltimoCodigoInstitucionNH.ultimoCodigoInstitucionNH.success) {
      const codInstitucion = 'NH' + dataUltimoCodigoInstitucionNH.ultimoCodigoInstitucionNH.valorEsperado;
      setUltimoCodigoInstitucionNH(codInstitucion);
      setFormValues({
        ...formValues,
        CodInstitucion: codInstitucion
      });
    };
  }, [dataUltimoCodigoInstitucionNH]);

  useEffect(() => {
    if (!errorUltimoCodigoInstitucionNH) return;
    setMensajeError("ERRORDB");
  }, [errorUltimoCodigoInstitucionNH]);

  const [getInstitucionesSAP, { error: errorInstitucionesSAP, data: dataInstitucionesSAP, loading: institucionesSAPLoading }] = useLazyQuery(GET_INSTITUCIONES_SAP, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataInstitucionesSAP) return;
    if (dataInstitucionesSAP.institucionesSAP.success) {
      const dataAll = dataInstitucionesSAP.institucionesSAP.valorEsperado;
      if (edit) {
        setInstitucionesSAP(dataAll);
        setInstitucionesSAPOriginal(dataAll);
      } else
      {
        if (institucion.idLocalidad == 0) {

          if (institucion.origen == 'SAP') {
            const resultado = dataAll.find((x) => x.cod_Institucion.toString() === institucion.cod_Institucion.toString());

            setFormValues({
              ...formValues,
              Domicilio: resultado.domicilio,
              IdProvincia: resultado.idProvincia,
              Localidad: resultado.localidad
            });
          }

        }
      }

      setInstitucionesSAPOriginalAll(dataAll);
    };
  }, [dataInstitucionesSAP]);

  useEffect(() => {
    if (!errorInstitucionesSAP) return;
    setMensajeError("ERRORDB");
  }, [errorInstitucionesSAP]);  

  const handleChangeNombre = (event) => {
    const { value } = event.target;

    setFormValues({
      ...formValues,
      Nombre: value.toUpperCase()
    });
  };

  const handleClickGrabar = () => {
    if (isFormValid()) {
      GuardarInstitucion();
    }
  };

  const isFormValid = () => {
    if (formValues.Activo) {
      if (formValues.IdDelegacion <= 0) {
        toast.error('Debe ingresar la delegación.');
        return false;
      }
      if (formValues.Nombre.length <= 0) {
        toast.error('Debe ingresar el nombre.');
        return false;
      }
      if (formValues.NombreFantasia.length <= 0) {
        toast.error('Debe ingresar el nombre de fantasia.');
        return false;
      }
      if (formValues.IdProvincia <= 0) {
        toast.error('Debe ingresar la provincia.');
        return false;
      }
      if (formValues.IdLocalidad <= 0) {
        toast.error('Debe ingresar la localidad.');
        return false;
      }
      if (formValues.Domicilio.length <= 0) {
        toast.error('Debe ingresar el domicilio.');
        return false;
      }
      if (formValues.TipoUnidad <= 0) {
        toast.error('Debe ingresar la unidad de soporte.');
        return false;
      }
      if (formValues.TipoInstitucion <= 0) {
        toast.error('Debe ingresar el tipo de institución.');
        return false;
      }
      if (comboDelegaciones.length <= 0) {
        toast.error('Debe ingresar al menos una delegación asociada.');
        return false;
      } else
      {
        const delegacion = delegaciones.find((x) => x.idDelegacion == formValues.IdDelegacion);
        if (!comboDelegaciones.includes(delegacion.descripcion)) {
          toast.error('No existe la delegación de origen como delegación asociada');
          return false;
        }
      }
    }

    return true;
  };

  const GuardarInstitucion = () => {
    const listaDelegaciones =
    delegaciones.filter((x) => {
      let resultado = comboDelegaciones.find((y) => {
        return y == x.descripcion;
      });
      return resultado != undefined;
    }).map((obj) => {
      return { idDelegacion: obj.idDelegacion, codInstitucion: '' };
    });

    if (edit && opcion === 2) {
      saveInstitucion({
        variables: {
          codInstitucion: formValues.CodInstitucion,
          nombre: formValues.Nombre,
          idDelegacion: formValues.IdDelegacion,
          origen: formValues.OrigenSAP ? 'SAP' : 'NSAP',
          nombreFantasia: formValues.NombreFantasia,
          domicilio: formValues.Domicilio,
          activo: true,
          tipoUnidad: formValues.TipoUnidad,
          idLocalidad: formValues.IdLocalidad,
          idProvincia: formValues.IdProvincia,
          tipoInstitucion: formValues.TipoInstitucion,
          listaDelegaciones: listaDelegaciones
        }
      });
    } else
    {
      updateInstitucion({
        variables: {
          codInstitucion: formValues.CodInstitucion,
          nombre: formValues.Nombre,
          idDelegacion: formValues.IdDelegacion,
          origen: formValues.OrigenSAP ? 'SAP' : 'NSAP',
          nombreFantasia: formValues.NombreFantasia,
          domicilio: formValues.Domicilio,
          activo: formValues.Activo,
          tipoUnidad: formValues.TipoUnidad,
          idLocalidad: formValues.IdLocalidad <= 0 ? null : formValues.IdLocalidad,
          idProvincia: formValues.IdProvincia <= 0 ? null : formValues.IdProvincia,
          tipoInstitucion: formValues.TipoInstitucion,
          listaDelegaciones: listaDelegaciones
        }
      });
    }

  };

  // handles de Dialog Instituciones SAP
  const handleSearchInstitucionSAP = () => {
    getInstitucionesSAP({ variables: { idDelegacion: delegacionSAP } });
  };

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (institucionesSAP.length > 0) {
      if (txtFiltro.current.value != "") {
        if (txtFiltro.current.value.length >= 3) {
          setInstitucionesSAP(institucionesSAPOriginal.filter((institucionesSAPOriginal) => {
            const codigoBuscar = institucionesSAPOriginal.cod_Institucion.toLowerCase();
            const nombreBuscar = institucionesSAPOriginal.nombre.toLowerCase();
            const cuitBuscar = institucionesSAPOriginal.cUIT.toString();

            const inputBuscar = txtFiltro.current.value;
            return (
              codigoBuscar.includes(inputBuscar) ||
              nombreBuscar.includes(inputBuscar) ||
              cuitBuscar.includes(inputBuscar));

          }
          ));
        }
      } else {
        setInstitucionesSAP(institucionesSAPOriginal);
      }
    }
  };

  const handleClean = () => {
    txtFiltro.current.value = "";
    handleSearch();
    txtFiltro.current.focus();
  };

  const handleRowClick = (params) => {
    const delegDato = delegaciones.filter((d) => d.descripcion.toUpperCase() == params.row.delegacion.toUpperCase())[0];
    setFormValues({
      ...formValues,
      CodInstitucion: params.row.cod_Institucion,
      Nombre: params.row.nombre,
      NombreFantasia: params.row.nombre,
      Domicilio: params.row.domicilio,
      IdDelegacion: delegDato.idDelegacion,
      Provincia: params.row.provincia,
      Localidad: params.row.localidad,
      IdProvincia: params.row.idProvincia
    });

    let resultado = delegaciones.find((x) => x.idDelegacion == delegDato.idDelegacion);
    if (resultado) {
      setComboDelegaciones([resultado.descripcion]);
    }

    setOpenDlgSAP(false);
    LimpiarDlgSAP();
  };

  const handleCloseDlgSAP = () => {
    setOpenDlgSAP(false);
    LimpiarDlgSAP();
  };

  const LimpiarDlgSAP = () => {
    setInstitucionesSAP([]);
    txtFiltro.current.value = "";
  };

  // handles de Dialog Localidades
  const handleSearchLocalidades = () => {
    if (!formValues.IdProvincia <= 0) {
      setOpenDlgLocalidades(true);
      setLoadingBuscarLocalidades(true);
      getLocalidades({ variables: { idProvincia: txtProvincia.current.value } });
    } else
    {
      toast.error('Para buscar una localidad, primero debe seleccionar una provincia');
    }
  };

  const handleSearchLocalidad = () => {
    const inputBuscar = normalizeFilterValue(txtFiltroLocalidad.current.value);
    if (inputBuscar != "") {
      setLocalidades(localidadesOriginal.filter((localidadesOriginal) => {
        const descripcionBuscar = localidadesOriginal.descripcion.toUpperCase();
        const codigoPostalBuscar = localidadesOriginal.codigoPostal.toUpperCase();

        return (
          descripcionBuscar.includes(inputBuscar) ||
          codigoPostalBuscar.includes(inputBuscar));

      }
      ));
    } else {
      setLocalidades(localidadesOriginal);
    }
  };

  const handleCleanLocalidad = () => {
    txtFiltroLocalidad.current.value = "";
    handleSearchLocalidad();
    txtFiltroLocalidad.current.focus();
  };

  const handleRowClickLocalidad = (params) => {

    setFormValues({
      ...formValues,
      Localidad: params.row.descripcion,
      IdLocalidad: params.row.idLocalidad
    });

    setLoadingBuscarLocalidades(false);

    setOpenDlgLocalidades(false);

    if (formValues.OrigenSAP)
    toast.success("La localidad fue seleccionada correctamente");
  };

  const handleCloseDlgLocalidad = () => {
    setOpenDlgLocalidades(false);
    setLoadingBuscarLocalidades(false);
  };

  const initialColumnsInstitutionSAP = [
  { field: 'delegacion', headerName: 'Delegación', flex: 0.2 },
  { field: 'cod_Institucion', headerName: 'Código', flex: 0.1 },
  { field: 'nombre', headerName: 'Nombre', flex: 0.5 },
  { field: 'cUIT', headerName: 'CUIT', flex: 0.2 }];


  const initialLocationColumns = [
  { field: 'descripcion', headerName: 'Localidad' },
  { field: 'codigoPostal', headerName: 'Codigo Postal' }];


  const columnsInstitutionSAP = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsInstitutionSAP, true), []);
  const columnsLocation = useMemo(() => generateColumnsDefaultConfiguration(initialLocationColumns), []);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const clickCancel = () => {
    navigate(URL_RETORNO);
  };

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
      personName.indexOf(name) === -1 ?
      theme.typography.fontWeightRegular :
      theme.typography.fontWeightMedium
    };
  }

  const handleChangeProvincia = (event) => {
    setFormValues(
      {
        ...formValues,
        IdProvincia: event.target.value,
        Localidad: '',
        IdLocalidad: null
      });
  };

  const handleChangeComboDelegaciones = (event) => {

    if (formValues.IdDelegacion <= 0) {
      toast.error('Primero debe seleccionar una delegación origen');
      return;
    }

    const { target: { value } } = event;

    if (value.includes(0)) {
      setComboDelegaciones(delegaciones.map((delegacion) => delegacion.descripcion));
    } else
    {
      setComboDelegaciones(
        typeof value === 'string' ? value.split(',') : value
      );
    }
  };

  const handleSAPClick = (e) => {
    setSelectedSAPFilter(e);
    const origenControl = Boolean(e) ? "SAP" : "NSAP";

    setOpenDlgSAP(Boolean(e));

    setFormValues(
      {
        ...formValues,
        Origen: origenControl,
        OrigenSAP: Boolean(e)
      });

    // reinicio los valores para NSAP
    if (!Boolean(e)) {
      setFormValues({
        CodInstitucion: ultimoCodigoInstitucionNH,
        Nombre: '',
        IdDelegacion: 0,
        Origen: '',
        OrigenSAP: false,
        NombreFantasia: '',
        Domicilio: '',
        Activo: true,
        TipoUnidad: 0,
        IdLocalidad: 0,
        IdProvincia: 0,
        TipoInstitucion: 0,
        Localidad: '',
        Provincia: '',
        ListaInstituciones: null
      });
      setComboDelegaciones([]);
    } else {
      getInstitucionesSAP({ variables: { idDelegacion: delegacionSAP } });
    }
  };

  const handleActivoClick = (e) => {
    setFormValues(
      {
        ...formValues,
        Activo: e.target.checked
      });
  };

  const handleClickActualizarDelegacion = () => {
    setFormValues({
      ...formValues,
      IdDelegacion: delegacionActualSAP
    });

    let resultado = delegaciones.find((x) => x.idDelegacion == delegacionActualSAP);
    if (resultado) {
      if (comboDelegaciones.length <= 1) {
        setComboDelegaciones([resultado.descripcion]);
      } else
      {
        if (!comboDelegaciones.includes(resultado.descripcion))
        setComboDelegaciones((current) => [...current, resultado.descripcion]);
      }
    }

    setMostrarActualizarDelegacion(false);
  };

  return (
    <>
            <div className='institucion-container'>
                <Grid
          container
          size={{ xs: 12, sm: 12 }}>
          
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <div className='institucion-linea-control' style={{ gap: '8px' }}>
                            <span className='span-row'>Origen</span>
                            <FormControl sx={{ backgroundColor: 'white' }} size="small">
                                <ButtonOptionGroup
                  options={['NSAP', 'SAP']}
                  onOptionClick={edit ? handleSAPClick : () => {}}
                  selectedOption={selectedSAPFilter}
                  disabled={!(edit && opcion === 2)} />
                
                            </FormControl>
                        </div>
                    </Grid>
                </Grid>
                <br />
                <Grid
          container
          size={{ xs: 12, sm: 12 }}
          spacing={2}>
          
                    <Grid size={{ xs: 12, md: 2 }}>
                        <TextInput
              label="Código"
              placeHolder='Código'
              value={formValues.CodInstitucion}
              name="Codigo"
              onChange={formHandle}
              disabled={true} />
            
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="select-delegacion">Delegacion</InputLabel>
                            <Select
                labelId="select-delegacion"
                id="Delegacion"
                value={formValues.IdDelegacion}
                label="Delegacion"
                inputRef={idDelegacion}
                onChange={(e) => {
                  setFormValues(
                    {
                      ...formValues,
                      IdDelegacion: e.target.value
                    });
                  let resultado = delegaciones.find((x) => x.idDelegacion == e.target.value);
                  if (resultado) {
                    if (comboDelegaciones.length <= 1) {
                      setComboDelegaciones([resultado.descripcion]);
                    } else
                    {
                      if (!comboDelegaciones.includes(resultado.descripcion))
                      setComboDelegaciones((current) => [...current, resultado.descripcion]);
                    }
                  }
                }
                }
                disabled={formValues.OrigenSAP}>
                
                                {delegaciones && delegaciones.map((delegacion) => {
                  return <MenuItem value={delegacion.idDelegacion}> {delegacion.descripcion} </MenuItem>;
                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 1 }}>
                        {mostrarActualizarDelegacion &&
            <CustomButton
              className='custom-buttom-primary-color-2'
              onClick={handleClickActualizarDelegacion}
              size='small'>
              
                                Actualizar
                            </CustomButton>
            }
                    </Grid>
                </Grid>
                <br />
                <Grid
          container
          spacing={2}>
          
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextInput
              label="Nombre"
              placeHolder="Nombre"
              name="Nombre"
              onChange={handleChangeNombre}
              value={formValues.Nombre}
              disabled={formValues.OrigenSAP} />
            
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextInput
              label="Nombre de Fantasía"
              placeHolder="Nombre de Fantasía"
              name="NombreFantasia"
              onChange={formHandle}
              value={formValues.NombreFantasia?.toUpperCase()}
              disabled={!edit} />
            
                    </Grid>
                </Grid>
                <br />
                <Grid
          container
          spacing={2}>
          
                    <Grid size={{ xs: 12, md: 12 }}>
                        <TextInput
              label="Domicilio"
              name="Domicilio"
              onChange={formHandle}
              value={formValues.Domicilio}
              disabled={!edit} />
            
                    </Grid>
                </Grid>
                <br />
                <Grid
          container
          spacing={2}>
          
                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="select-provincia">Provincia</InputLabel>
                            <Select
                labelId="select-provincia"
                id="select-provincia"
                name="Provincia"
                value={formValues.IdProvincia}
                label="Provincia"
                inputRef={txtProvincia}
                disabled={!edit}
                onChange={handleChangeProvincia}>
                
                                {provincias && provincias.map((provincia) => {
                  return <MenuItem key={provincia.idProvincia} value={provincia.idProvincia}> {provincia.descripcion} </MenuItem>;
                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 5 }}>
                        <TextInput
              label="Localidad"
              name="Localidad"
              searchIcon
              onChange={formHandle}
              onClick={handleSearchLocalidades}
              value={formValues.Localidad} />
            
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        {formValues.OrigenSAP && formValues.CodInstitucion != '' && formValues.IdLocalidad <= 0 &&
            <div style={{ fontSize: '12px', boxSizing: 'border-box', padding: '0px', margin: '0px' }}>* La localidad seleccionada es a modo sugerido. Deberá ingresarla nuevamente para confirmarla.</div>
            }
                    </Grid>
                </Grid>
                <br />
                <Grid
          container
          spacing={2}>
          
                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="select-unidadSoporte">Unidad Soporte</InputLabel>
                            <Select
                labelId="select-unidadSoporte"
                id="UnidadSoporte"
                value={formValues.TipoUnidad}
                label="Unidad Soporte"
                disabled={!edit}
                onChange={(e) => setFormValues(
                  {
                    ...formValues,
                    TipoUnidad: e.target.value
                  })
                }>
                
                                {unidadesSoporte && unidadesSoporte.map((unidadSoporte) => {
                  return <MenuItem value={unidadSoporte.id}> {unidadSoporte.descripcion} </MenuItem>;
                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <InputLabel id="select-tipoInstitucion">Tipo Institución</InputLabel>
                                <Select
                  labelId="select-tipoInstitucion"
                  id="TipoInstitucion"
                  name="TipoInstitucion"
                  value={formValues.TipoInstitucion}
                  label="Tipo Institución"
                  disabled={!edit}
                  onChange={(e) => setFormValues(
                    {
                      ...formValues,
                      TipoInstitucion: e.target.value
                    })
                  }>
                  
                                    {tipoInstituciones && tipoInstituciones.map((tipoInstitucion) => {
                    return <MenuItem value={tipoInstitucion.id}> {tipoInstitucion.descripcion} </MenuItem>;
                  })}
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid
          container
          spacing={2}>
          
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 12, md: 12, lg: 12 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="multiple-chip-label">Delegaciones Asociadas</InputLabel>
                            <Select
                labelId="multiple-chip-label"
                label="Delegaciones Asociadas"
                id="multiple-chip"
                name="multiple-chip"
                multiple
                value={comboDelegaciones}
                onChange={handleChangeComboDelegaciones}
                renderValue={(selected) =>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) =>
                  <Chip key={value} label={value} />
                  )}
                                    </Box>
                }>
                
                                <MenuItem
                  key={0}
                  value={0}>
                  
                                    TODAS
                                </MenuItem>
                                {delegaciones.map((delegacion) =>
                <MenuItem
                  key={delegacion.idDelegacion}
                  value={delegacion.descripcion}
                  style={getStyles(delegacion, comboDelegaciones, theme)}>
                  
                                        {delegacion.descripcion}
                                    </MenuItem>
                )}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                {
        edit &&
        <Grid
          container
          spacing={0}>
          
                        <Grid size={{ xs: 12, md: 3 }}>
                            <div className='institucion-linea-control' style={{ gap: '8px' }}>
                                <div className='switch-row'>
                                    <span className='span-row'>Activo</span>
                                    <SwitchInput
                  onChange={handleActivoClick}
                  name='Activo'
                  checked={formValues.Activo}
                  className='switch-row container'
                  disabled={edit && opcion === 2} />
                
                                </div>
                            </div>
                        </Grid>
                    </Grid>
        }
            </div>

            <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      

            <CustomDialog
        maxWidth="md"
        fullWidth={true}
        open={openDlgSAP}
        title='Búsqueda de Instituciones SAP'
        onCancel={handleCloseDlgSAP}
        cancelText='Cancelar'>
        
                <Stack direction="row" spacing={1} alignItems="center">
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <TextField
              label="Filtrar"
              name="txtFiltro"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtFiltro}
              onKeyUp={handleSearch}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                <InputAdornment position="end">
                                        <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />
                  
                                        <ClearIcon
                    onClick={handleClean}
                    sx={{ cursor: 'pointer' }} />
                  
                                    </InputAdornment>

              }} />
            
                    </FormControl>

                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <InputLabel id="select-delegacion">Delegacion</InputLabel>
                        <Select
              labelId="select-delegacion"
              id="Delegacion"
              value={delegacionSAP}
              label="Delegacion"
              onChange={(e) =>
              setDelegacionSAP(e.target.value)
              }>
              
                            <MenuItem value={0}>TODAS</MenuItem>
                            {delegaciones && delegaciones.map((delegacion) => {
                return <MenuItem value={delegacion.idDelegacion}> {delegacion.descripcion} </MenuItem>;
              })}
                        </Select>
                    </FormControl>

                    <CustomButton
            isLoading={loadingBuscarInstitucionSAP}
            onClick={handleSearchInstitucionSAP}>
            
                        Buscar
                    </CustomButton>
                </Stack>
                <br />
                <DataGridGenerico
          columns={columnsInstitutionSAP}
          rows={institucionesSAP}
          toolbar={false}
          onRowClick={handleRowClick}
          loading={institucionesSAPLoading} />
        
            </CustomDialog>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgLocalidades}
        title='Búsqueda de Localidades'
        onCancel={handleCloseDlgLocalidad}
        cancelText='Cerrar'>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <TextField
                label="Filtrar"
                name="txtFiltroLocalidad"
                size="small"
                type="text"
                variant="outlined"
                inputRef={txtFiltroLocalidad}
                onKeyUp={handleSearchLocalidad}
                sx={{ backgroundColor: 'white' }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position="end">
                                            <SearchIcon
                      onClick={handleSearchLocalidad}
                      sx={{ cursor: 'pointer' }} />
                    
                                            <ClearIcon
                      onClick={handleCleanLocalidad}
                      sx={{ cursor: 'pointer' }} />
                    
                                        </InputAdornment>

                }} />
              
                        </div>
                    </FormControl>
                </div>

                <br />

                <DataGridGenerico
          columns={columnsLocation}
          rows={localidades}
          toolbar={false}
          onRowClick={handleRowClickLocalidad}
          loading={localidadesLoading} />
        
            </CustomDialog>
        </>);

}